import _JSXStyle from "styled-jsx/style";
import { colors, spacers } from '@dhis2/ui-constants';
import cx from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
export const ModalTitle = _ref => {
  let {
    children,
    dataTest = 'dhis2-uicore-modaltitle'
  } = _ref;
  return /*#__PURE__*/React.createElement("h1", {
    "data-test": dataTest,
    className: _JSXStyle.dynamic([["4169842822", [colors.grey900, spacers.dp12]]]) + " " + (cx('title') || "")
  }, children, /*#__PURE__*/React.createElement(_JSXStyle, {
    id: "4169842822",
    dynamic: [colors.grey900, spacers.dp12]
  }, [`h1.__jsx-style-dynamic-selector{-webkit-order:1;-ms-flex-order:1;order:1;-webkit-align-self:flex-start;-ms-flex-item-align:start;align-self:flex-start;color:${colors.grey900};font-size:20px;font-weight:500;line-height:24px;margin:0 0 ${spacers.dp12};}`]));
};
ModalTitle.propTypes = {
  children: PropTypes.node,
  dataTest: PropTypes.string
};